enum StorageKeyOptionsEnum {
  AccessData = 'access_data',
  Tokens = 'tokens',
  OrganizationsData = 'organizations_data',
  FarmsData = 'farms_data',
}

export { StorageKeyOptionsEnum };
